const WhyUsCard = [
    {
        id: 1,
        heading: 'Reliable and Professional',
        text: 'Reliable, professional cleaners. Timely, high-quality service. Trust us with your space.'
    },
    {
        id: 2,
        heading: 'Affordable and Adaptable',
        text: 'Affordable, adaptable cleaning plans designed to meet your specific needs and budget.'
    },
    {
        id: 3,
        heading: 'Experienced and Skilled Team',
        text: 'Experience the difference with our skilled team for a truly immaculate home.'
    },
    {
        id: 4,
        heading: 'Thorough and Meticulous',
        text: 'Enjoy our meticulous attention to detail for a consistently spotless and refreshing home.'
    },


]

export default WhyUsCard;